import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from "react";
import styled from "styled-components";

const ColorButton = styled.div`
  background: ${(props) => props.$currColor};
  border-radius: 50%;
  display: inline-block;
  height: max(16px, 1vw);
  margin-right: 10px;
  width: max(16px, 1vw);

  &:hover {
    cursor: pointer;
  }
`;  

const ColorMenu = ({ colorOptions, currColor, inEditMode, setUserColor }) => {
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);

  const handleClick = (e) => {
    setAnchor(e.currentTarget);
  };

  const handleOptionClick = (selectedColor) => {
    setUserColor(selectedColor);
    handleClose();
  };

  const handleClose = () => {
    setAnchor(null);
  };

  return (
    <>
      <ColorButton
        $currColor={colorOptions.find((o) => o.label === currColor).hex}
        aria-controls={open ? 'color-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        id="color-button"
        onClick={(e) => handleClick(e)}
      />

      <Menu
        anchorEl={anchor}
        id="color-menu"
        MenuListProps={{
          'aria-labelledby': 'color-button',
        }}
        onClose={() => handleClose()}
        open={open}
      >
        {colorOptions.map((option) => {
          return (
            <MenuItem onClick={() => handleOptionClick(option.hex)}>
              {option.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default ColorMenu;
